module.exports = __webpack_public_path__ + "img/bank-10-mg.554a52f1.svg";